__turbopack_context__.v({
  "card": "HdStQa_card",
  "content": "HdStQa_content",
  "description": "HdStQa_description",
  "label": "HdStQa_label",
  "labelGroup": "HdStQa_labelGroup",
  "left": "HdStQa_left",
  "rightContent": "HdStQa_rightContent",
  "separator": "HdStQa_separator",
});
